export const TABS = [
  {
    label: 'Agendadas',
    value: 'scheduled',
  },
  {
    label: 'Realizadas',
    value: 'performed',
  },
  {
    label: 'Canceladas',
    value: 'cancelled',
  },
]

export const MAP_STATUS_FROM_PV_TO_CONEXA = {
  A_REALIZAR: 'PENDENTE',
  CANCELADA: 'CANCELADO',
  NO_SHOW: 'CANCELADO',
  NO_SHOW_PAC: 'CANCELADO',
  NO_SHOW_PSI: 'CANCELADO',
}
